import React, { useState } from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import M_Footer from './M_Footer';
import { Link } from 'react-router-dom';
import TopTitle from './TopTitle';
import queryString from 'query-string';
import axios from 'axios';
import {CustomAlert2,ContractCheckAlert,instance} from './common';

function checkNum(inputs,popup,setPopup){

    let obj = {co_number:inputs}

    const fetchData = async () => {
        instance.post('/contract/check',obj).then(function(res){
            
            if(res.data.msg == 'nodata'){
                setPopup({
                    ...popup,
                    no:true,
                });
            }else if(res.data.msg == 'success'){
                

                let obj = {contract_num:res.data.rows[0].co_number}
                const fetchData = async () => {
                    instance.post('/reserve/check',obj).then(function(res){
                        console.log('res.data : ', res.data)
                        if(res.data.msg == 'exist'){
                           alert('이미 존재');
                        }else{
                            if(res.data.rows[0].co_pro == 1){
                                popup.pro =1
                            }
            
                            setPopup({
                                ...popup,
                                ok:true,
                            });
                        }
                    });
                    
                };
            
                fetchData();

                
            }
        });
        
    };

    fetchData();

    
}



function RepCheck({history, location, match}) {


    const [inputs, setInputs]  = useState('');


    const [popup, setPopup] = useState({
        ok:false,
        no:false,
        pro:0
    });

    const {ok,no,pro} = popup;
    const goBack = () => {
        history.goBack();
    };

    const onClick = () => {
        checkNum(inputs,popup,setPopup);
        
    }

    const onChange = (e) => {
        const {name,value} = e.target;
        setInputs(value);
    }


    console.log('popup : ', popup)
  return (
    
    <>
    {
        ok && <ContractCheckAlert history={history} pro={pro} inputs={inputs}/>
    }
    {
        no && <CustomAlert2 setPopup={setPopup} popup={popup}/>
    }
    
    <TopTitle title="계약번호 입력"/>
    <Container>
        <div className="c_pad">
            <h5 className="font-weight-bold mb-3">계약번호를 입력해주세요.</h5>
            <div className="c_flex c_boxshadow">
                <div className="col">
                    <input name="num1" autoComplete="off" type="text" className="c_border" value={inputs} onChange={onChange} />
                </div>
            </div>
            <div className="c_flex">
                <div className="c_certify my-3">계약번호를 - 없이 입력해주세요</div>
            </div>
            <div className="btn btn-primary c_coupon_btn r_btnsize" onClick={onClick}>등록</div>
            <div>
                <span className="btn btn-primary r_btnsize mt-3" onClick={goBack}>뒤로가기</span>
            </div>
        </div>
        
    </Container>
    </>
    
  );
}

export default RepCheck;